import React, { useMemo } from "react";
import DOMPurify from "dompurify";

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

const SafeHtml = ({ content, className = "" }) => {
  const sanitizedContent = useMemo(() => {
    const raw = (content ?? "").toString();
    if (!raw) return "";
    return DOMPurify.sanitize(raw, {
      ADD_ATTR: ["target"],
    });
  }, [content]);

  if (!sanitizedContent) return null;

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
};

export default SafeHtml;
